export default {
      id: "eclaircies-usage",
      viewBox: "0 0 91 91",
      url: "../dist/images/" + "sprite.svg#eclaircies-usage",
      toString: function () {
        return this.url;
      }
    }